function setProductAsPreorder() {
  if(document.querySelector(".gPreorderNAMessage")==null){
    addPreorderReleaseDate();
  }else{
    removePreorderReleaseDate();
    hideLoaderForNotAvailableButton();
  }
  displayPreOrderLabel("flex");
  displayProductTitleTagLabel("none");
  setInstallmentInfoForPreorder();
  changeShippingText(true);
  changeVisibilityBackInStockButton("none");
  setPreOrderOOSBanner()
}

function setProductAsDefault() {
  removePreorderReleaseDate();
  displayPreOrderLabel("none");
  displayProductTitleTagLabel("flex");
  setInstallmentInfoForDefault();
  changeShippingText(false);
  changeVisibilityBackInStockButton("flex");
}

const onAddToCartFormMutated = (mutationList) => {
  for (const mutation of mutationList) {
    if (mutation.type === 'childList') {
      for (const addedNode of mutation.addedNodes) {
        if (isElement(addedNode)) {
          if(addedNode.getAttribute("name") === "properties[_is_preorder]" ||
            (addedNode.getAttribute("class") != null && addedNode.getAttribute("class").includes("gPreorderNAMessage")) ||
            (addedNode.getAttribute("id") != null && addedNode.getAttribute("id").includes("Globo-Back-In-Stock"))){
              if(isPreorderProduct()){
                setProductAsPreorder();
              }else{
                setProductAsDefault();
              }
            }
        }
      }
      for (const removedNode of mutation.removedNodes) {
        if (isElement(removedNode)) {
          if((removedNode.getAttribute("name") != null && removedNode.getAttribute("name") === "properties[_is_preorder]") ||
            (removedNode.getAttribute("class") != null && removedNode.getAttribute("class").includes("gPreorderNAMessage")) ||
            (removedNode.getAttribute("id") != null && removedNode.getAttribute("id").includes("Globo-Back-In-Stock"))){
              if(isPreorderProduct()){
                setProductAsPreorder();
              }else{
                setProductAsDefault();
              }
            }
        }
      }
    }
  }
};

const addToCartFormObserver = new MutationObserver(onAddToCartFormMutated);

function isElement(obj) {
  try { // Using W3 DOM2 (works for FF, Opera and Chrome)
    return obj instanceof HTMLElement;
  } catch (e) {

// Browsers not supporting W3 DOM2 don't have HTMLElement and
// an exception is thrown and we end up here. Testing some
// properties that all elements have (works on IE7)
    return(typeof obj === "object") && (obj.nodeType === 1) && (typeof obj.style === "object") && (typeof obj.ownerDocument === "object");
  }
}

function checkIsPreorderProductIfPreorderLoadedAvailable() {
  var preorderLoaded = document.querySelector("form#"+productFormId);
  if (!preorderLoaded) {

// The node we need does not exist yet.
// Wait 500ms and try again
    window.setTimeout(checkIsPreorderProductIfPreorderLoadedAvailable, 500);
    return;
  }
  const config = {
    subtree: true,
    attributes: true,
    childList: true
  };
  addToCartFormObserver.observe(preorderLoaded, config);
  
  if(isPreorderProduct()){
    setProductAsPreorder();
  }else{
    setProductAsDefault();
  }
}

function addPreorderReleaseDate() {
  if (!document.querySelector('[name="properties[_preorder_tag]"]')){
    const releaseDateElement = document.createElement("input");
    releaseDateElement.setAttribute("type", "hidden");
    releaseDateElement.setAttribute("name", "properties[_preorder_tag]");

// convertReleaseDateToSendDate get from global.js
    releaseDateElement.setAttribute("value", tag);
    document.querySelector("#"+productFormId).appendChild(releaseDateElement);
  }
}

function removePreorderReleaseDate() {
  var preorderReleaseDateSelector = document.querySelector('[name="properties[_preorder_tag]"]');
  if (preorderReleaseDateSelector) {
    preorderReleaseDateSelector.remove();
  }
}

function setInstallmentInfoForPreorder() {
  const installmentModalOpener = document.querySelector('installment-modal-opener');
  const installmentModalTickers = document.querySelectorAll('.installments-info-ticker');
  installmentModalOpener.dataset.installmentScheme = "preorder";
  installmentModalTickers.forEach(ticker => {
    ticker.classList.remove('hidden');
  });
}

function setInstallmentInfoForDefault() {
  const installmentModalOpener = document.querySelector('installment-modal-opener');
  const installmentModalTickers = document.querySelectorAll('.installments-info-ticker');
  installmentModalOpener.dataset.installmentScheme = "regular";
  installmentModalTickers.forEach(ticker => {
    ticker.classList.add('hidden');
  });
}

function displayPreOrderLabel(displayValue) {
  var preOrderLabelSelector = document.querySelector('.product__title-pre-order-label');
  preOrderLabelSelector.style.display = displayValue;
}

function displayProductTitleTagLabel(displayValue) {
  var productTitleTag = document.querySelector('.product__title-tag');
  productTitleTag.style.display = displayValue;
}

function changeShippingText(isPreorder) {
  if (isPreorder) {
    changeVisibilityPickupStoreAvailability("none");
  } else {
    changeVisibilityPickupStoreAvailability("flex");
  }
}
function changeVisibilityPickupStoreAvailability(displayValue) {
  const pickupStoreAvailability = document.getElementsByClassName('delivery-location-availability');
  for (let store of pickupStoreAvailability) {
    store.style.display = displayValue;
  }
}

function changeVisibilityBackInStockButton(displayValue) {
  setTimeout(() => {
    const backInstockButton = document.querySelector('.gBackInStockBtn');
    if (backInstockButton) {
      backInstockButton.style.display = displayValue;
    }
  }, 100);
}

function isPreorderProduct(){
  const productId = document.querySelector('#'+productFormId+' input[name="product-id"]');
  const preorderProduct = getPreorderSettingsBackup().products;
  if(preorderProduct[productId.value] != null) return true;
  return false;
}

function hideLoaderForNotAvailableButton(){
  const notAvailableLoader = document.querySelector(".gPreorderNAMessage .loading-overlay__spinner");
  if(notAvailableLoader){
    notAvailableLoader.classList.add("hidden");
  }
}

function setPreOrderOOSBanner() {
  setTimeout(() => {
    const {
      preorderSettings: { products },
      product: { id: mainProductId },
    } = window.Globo.Preorder.settings

    const productVariantId = document.querySelector("form[id^='product-form-installment-template--'] input[name='id']").value
    const product = products[mainProductId]
    const preorderTagInput = document.querySelector('input[name="properties[_preorder_tag]"]')
    const preOrderTag = document.getElementById("preorder-tag")
    const gPreorderNAMessage = document.querySelector(".gPreorderNAMessage")
    const preOrderTagData = preOrderTag?.getAttribute("data-preorder-tag")
    const preOrderDate = preOrderTagData?.split('@')[1]

    const oosTicker = document.getElementById('oos-ticker')
    const oosTickerHeader = document.getElementById('oos-ticker-header')
    const oosTickerBody = document.getElementById('oos-ticker-body')

    let endDate = ""

    const extractDate = (conditions, type) => {
      const parsedConditions = JSON.parse(conditions)
      return parsedConditions.find(cond => cond.type === type)?.condition?.split("T")[0]
    };

    const processProductOrVariant = (entity) => {
      if (entity.end_condition) {
        endDate = extractDate(entity.end_condition, 'date')
      }
    };

    const parseRawDateToNewDate = (rawDate)=>{
      var day = parseInt(rawDate.substring(0,2));
      var month = parseInt(rawDate.substring(2,4))-1;
      var year = parseInt(rawDate.substring(4,8));
      return new Date(year, month, day);
    }

    if (product && typeof product === 'object') {
      if (product.hasOwnProperty('start_condition')) {
        processProductOrVariant(product)
      } else {
        processProductOrVariant(product[productVariantId])
      }
    }
    if (preOrderTagData && !preorderTagInput?.value && gPreorderNAMessage && new Date() < parseRawDateToNewDate(preOrderDate)) {
      oosTicker.style.display = "block"
      oosTickerHeader.innerHTML = "Terima kasih atas ketertarikannya"
      if (new Date(endDate) < new Date()) {
        oosTickerBody.innerHTML = `Produk ini akan tersedia pada 
        ${parseRawDateToDate(preOrderDate)}. Klik <b>“Beritahu saya”</b> untuk jadi yang pertama tahu saat tersedia!`
      } else {
        oosTickerBody.innerHTML = `Stok pre-order kami habis, tapi jangan khawatir, produk ini akan tersedia pada 
        ${parseRawDateToDate(preOrderDate)}. Klik <b>“Beritahu saya”</b> untuk jadi yang pertama tahu saat tersedia!`
      }
      changeVisibilityBackInStockButton("flex")
    } else {
      oosTicker.style.display = "none"
      changeVisibilityBackInStockButton("none")
    }
  }, 100)
}
setTimeout(() => {
    checkIsPreorderProductIfPreorderLoadedAvailable();
  }, 200);